module.exports = __webpack_public_path__ + "img/product-shot_04.b053e829.jpg";